interface ResponseAO {
  [key: string]: unknown;
  count: number;
}

export const valuationsToApp = (response: ResponseAO) => ({
  valuationsCount: response.count,
});
